import { useListView } from '../../core/ListViewProvider'
import { ListToolbar } from './ListToolbar'
import { ListGrouping } from './ListGrouping'
import { ListSearchComponent } from './ListSearchComponent'
// import { ListSelectPage } from './ListSelectPage'
import { PageTitleWrapper } from '../../../../../../../../_metronic/layout/components/toolbar/page-title'
import { ListFilter } from './ListFilter'

const ListHeader = () => {
  const { selected } = useListView()
  return (
    <>
      <div className='card-header border-0'>
        <div className='card-toolbar'>
          <PageTitleWrapper />
        </div>
        {/* begin::Card toolbar */}
        <div className='card-toolbar'>
          {/* begin::Group actions */}
          {selected.length > 0 ? <ListGrouping /> : <ListToolbar />}
          {/* end::Group actions */}
        </div>
        {/* end::Card toolbar */}
      </div>
      <div className='separator separator-dashed'></div>
      <div className='card-header border-0'>
        {/* <ListSelectPage /> */}
        <ListFilter />
        <ListSearchComponent />
        <div className='d-flex align-items-center position-relative my-1'></div>
        <div className='d-flex align-items-center position-relative my-1'></div>
      </div>
    </>
  )
}

export { ListHeader }
